module.exports = __webpack_public_path__ + "static/img/3-6.4c0a705.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/3-6.jpg
// module id = FyeZ
// module chunks = 1